import {GetPollResponsePayload} from '../../../../shared/models/api';
import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AppActions} from '../../../actions';

export interface PollsDetailsState {
  poll: GetPollResponsePayload | null;
}

const initialState: PollsDetailsState = {poll: null};

export const pollDetailsSlice = createSlice({
  name: '@@eskso/polls/details',
  initialState,
  reducers: {
    setPoll: (state, action: PayloadAction<GetPollResponsePayload | null>) => {
      return {
        ...state,
        poll: action.payload,
      };
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});
